import { useState, useEffect, useCallback } from "react";

export function useFileManager(
  hpcode: number, // ★ hpcode を追加
  roomId: number,
  honbuId: number,
  currentFolderId: string | null,
) {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchFiles = useCallback(async () => {
    setIsLoading(true);
    try {
      // ★ URL に hpcode=${hpcode} を追加
      const url = `/api/files/list?hpcode=${hpcode}&roomId=${roomId}&honbuId=${honbuId}${
        currentFolderId ? `&folderId=${currentFolderId}` : ""
      }`;

      const res = await fetch(url);
      if (res.ok) {
        setData(await res.json());
      }
    } catch (error) {
      console.error("Failed to fetch files:", error);
    } finally {
      setIsLoading(false);
    }
  }, [hpcode, roomId, honbuId, currentFolderId]); // ★ 依存配列に hpcode を追加

  useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);

  return { data, isLoading, refresh: fetchFiles };
}
